import { type MessageDescriptor } from "react-intl";

import i18nService from "@app/config/I18nService";

// i18nService.formatMessage needs the defaultMessage string as its 2nd arg — wrap that once.
const formatMessage = (
  descriptor: MessageDescriptor,
  values?: Parameters<typeof i18nService.formatMessage>[2]
): string => i18nService.formatMessage(descriptor, String(descriptor.defaultMessage ?? ""), values);

export default formatMessage;
